import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { g as getTranslationComponent } from '../i18n/AbandonmentDialogTranslation/index-BzSLd1UN.js';
import { M as Modal } from '../Modal/Modal-BWQMUu5q.js';
import { S as SecondaryView } from '../SecondaryView/SecondaryView-D6y2TSS-.js';
import { u as useIsMobile } from '../theme/MobileThemeProvider/useIsMobile-B-VP6bHU.js';
import { T as Text } from '../Text/Text-CO4HftGt.js';
import { C as CancelButton } from './DefaultAbandonmentFooter/CancelButton-B1_xrFpa.js';
import { L as LeaveButton } from './DefaultAbandonmentFooter/LeaveButton-UqaLapeo.js';
import { p as paddingMixin, m as mobilePaddingMixin } from '../theme/style-mixins/padding/index-BPYuRWh5.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { I as IntlProvider } from '../LocalModules/storm-ui-intl/dist/esm/IntlProvider-DUNZ897o-Dn-1_05J.js';
import { u as useIntl } from '../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-voJ4yxcS-DU7lWLPF.js';
import { D as DefaultAbandonmentFooter } from './DefaultAbandonmentFooter/DefaultAbandonmentFooter-ButsjesZ.js';
import { H as Heading } from '../Heading/Heading-_71dBU2D.js';

const ChildrenWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40026394__sc-j8k5ou-0"
})(["", " ", ""], paddingMixin, isMobile(css(["", ""], mobilePaddingMixin)));
const AbandonmentDialogContent = ({
  isOpen,
  onCancel,
  onLeave,
  padding = 'base',
  paddingBlockStart,
  paddingBlockEnd,
  paddingInlineStart,
  paddingInlineEnd,
  renderHeader,
  renderFooter,
  taktId,
  children,
  ...rest
}) => {
  const isMobile = useIsMobile();
  const {
    formatMessage
  } = useIntl();
  const getDefaultHeader = () => isMobile ? /*#__PURE__*/React__default.createElement(Heading, {
    size: "medium"
  }, formatMessage({
    id: 'default_abandonment_header'
  })) : formatMessage({
    id: 'default_abandonment_header'
  });
  const header = renderHeader ? renderHeader() : getDefaultHeader();
  const footer = renderFooter ? renderFooter({
    handleCancel: onCancel,
    handleLeave: onLeave
  }) : /*#__PURE__*/React__default.createElement(DefaultAbandonmentFooter, _extends({}, rest, {
    onCancel: onCancel,
    onLeave: onLeave
  }));
  return isMobile ? /*#__PURE__*/React__default.createElement(SecondaryView, _extends({}, rest, {
    padding: padding,
    paddingBlockStart: paddingBlockStart,
    paddingBlockEnd: paddingBlockEnd,
    paddingInlineStart: paddingInlineStart,
    paddingInlineEnd: paddingInlineEnd,
    isOpen: isOpen,
    onClose: onCancel,
    closeButtonLabel: formatMessage({
      id: 'cancel'
    }),
    taktId: taktId
  }), header, /*#__PURE__*/React__default.createElement(ChildrenWrapper, {
    $padding: padding,
    $paddingBlockStart: paddingBlockStart,
    $paddingBlockEnd: paddingBlockEnd,
    $paddingInlineStart: paddingInlineStart,
    $paddingInlineEnd: paddingInlineEnd
  }, children !== null && children !== void 0 ? children : /*#__PURE__*/React__default.createElement(Text, null, formatMessage({
    id: 'default_abandonment_body'
  }))), footer) : /*#__PURE__*/React__default.createElement(Modal, _extends({}, rest, {
    padding: "none",
    isOpen: isOpen,
    header: header,
    footer: footer,
    onClose: onCancel,
    taktId: taktId
  }), /*#__PURE__*/React__default.createElement(ChildrenWrapper, {
    $padding: padding,
    $paddingBlockStart: paddingBlockStart,
    $paddingBlockEnd: paddingBlockEnd,
    $paddingInlineStart: paddingInlineStart,
    $paddingInlineEnd: paddingInlineEnd
  }, children !== null && children !== void 0 ? children : /*#__PURE__*/React__default.createElement(Text, null, formatMessage({
    id: 'default_abandonment_body'
  }))));
};

// eslint-disable-next-line max-len

const AbandonmentDialog = ({
  locale = 'en-US',
  onError,
  fallback,
  onReset,
  ...rest
}) => {
  const translations = getTranslationComponent(locale);
  return /*#__PURE__*/React__default.createElement(IntlProvider, {
    onError: onError,
    resetKey: locale,
    fallback: fallback,
    onReset: onReset,
    translations: translations
  }, /*#__PURE__*/React__default.createElement(AbandonmentDialogContent, rest));
};
AbandonmentDialog.Cancel = CancelButton;
AbandonmentDialog.Leave = LeaveButton;

export { AbandonmentDialog as A };
//# sourceMappingURL=AbandonmentDialog-ZQ9YaB8u.js.map
